const stickyDrawerConfig = {
	style: {
		background: `var(--color-functional-panelLight)`,
		boxShadow: `var(--elevation-shadow-xl)`,
		padding: {
			small: `var(--spacing-global-space6) var(--spacing-global-space5)`,
			medium: `var(--spacing-global-space7) var(--spacing-global-space6)`,
		},
	},
};

const { style } = stickyDrawerConfig;

export default stickyDrawerConfig;
export { style };
